import Stacks from "../objects/stacks";
import { selectedElementAll } from "../utils/element-handlers.utils";

function StacksComponent(stackNavElement: HTMLElement, id: string) {
    new Stacks(stackNavElement, id)
}

export default function initStacksComponent() {
    selectedElementAll('.n-stacks', element => {
        if (element.id) {
            StacksComponent(element, element.id);
        }
    });
};
